import React, { useState } from "react";
import "./LandingPage5.css";

const LandingPage5 = ({ faqData }) => {
  const [activeFaq, setActiveFaq] = useState("");

  const toggleFaq = (faqId) => {
    setActiveFaq(activeFaq === faqId ? "" : faqId);
  };

  return (
    <div className="editor-page">
      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          <h1 className="faq-heading">
            Frequently Asked <span className="highlighted">Questions</span>
          </h1>
          <div className="faq-list">
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className={`faq-item ${activeFaq === faq.id ? 'active' : ''}`}
                onClick={() => toggleFaq(faq.id)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <span className="faq-icon">
                    {activeFaq === faq.id ? '−' : '+'}
                  </span>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Editor Section */}
      <section className="editor-hero">
        <div className="editor-hero-content">
          <div className="editor-hero-text">
            <h1>
              Generate Best Furniture <br />
              Images with AI in Shutter Editor
            </h1>
            <p>
              Furniture brands reduce expenses on photoshoots and 3d renders <br />
              with our ai to create stunning furniture visuals.
            </p>
            <div className="editor-buttons" onClick={() => window.location.href = 'https://api.leadconnectorhq.com/widget/booking/q47rHzIRXjxEby7Q2zqi'}>
              <button className="demo-btn">Book a Demo</button>
              <button className="credits-btn">
                <span className="coin">🪙</span>
                Claim 100 Free Credits
              </button>
            </div>
          </div>
          <div className="editor-hero-image">
            <div className="image-grid">
              <img
                src="https://storage.googleapis.com/a1aa/image/20493243-b94c-4a4e-c782-7d77442a13a4.jpg"
                alt="Black and white modern chair"
                className="img1"
              />
              <img
                src="https://storage.googleapis.com/a1aa/image/f00d7619-fa70-4a3d-48ba-3d8d583f1ca3.jpg"
                alt="Modern chair with orange background"
                className="img2"
              />
              <img
                src="https://storage.googleapis.com/a1aa/image/14c41986-733f-48e0-6500-207574e70a34.jpg"
                alt="Modern chair with blue background"
                className="img3"
              />
              <img
                src="https://storage.googleapis.com/a1aa/image/7bd75289-9c7c-4c95-7198-4abd4c4d8a28.jpg"
                alt="Smiling man"
                className="img4"
              />
            </div>
          </div>
        </div>

        {/* Shutter Watermark */}
        <h2 className="editor-watermark" aria-hidden="true">
          Shutter
        </h2>
      </section>

      <footer className="editor-footer">
        <div>© 2025. All Rights Reserved.</div>
        <nav className="footer-nav">
          {/* <div className="footer-col">
            <a href="#">Home</a>
            <a href="#">About Us</a>
            <a href="#">Pricing</a>
          </div> */}
          <div className="footer-col">
            {/* <a href="#">Privacy Policy</a> */}
            <a 
              href="/terms-and-conditions" 
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View Terms and Conditions"
            >
              Terms & Conditions
            </a>
            {/* <a href="#">Cookies Policy</a> */}
          </div>
        </nav>
        {/* <div className="footer-socials">
          <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
          <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
          <a href="#" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
          <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
        </div> */}
      </footer>
    </div>
  );
};

export default LandingPage5;
